export const BRAND_FACET_CODE = "brands" as const;
export const BRAND_FACET_NAME = "Brands" as const;
export const PRODUCTS_COLLECTION_SLUG = "products" as const;
export const BRANDS_FETCH_TAKE = 10000;

export const ALPHABET = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("") as readonly string[];

export const BRANDS_PAGE_TEXT = {
    HOME: "Home",
    TITLE: "Brands",
    ALL: "ALL",
    OTHER: "#",
    EMPTY: "No brands found.",
    DOWNLOAD_PREORDER_BRANDLISTS: "Download Pre-order brandlists",
} as const;

export function slugifyBrandName(name: string): string {
    if (!name) {
        return "";
    }
    return name
        .trim()
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/\s+/g, " ")
        .replace(/[^\w\s]/g, "")
        .trim()
        .replace(/\s+/g, "-");
}

export function brandSlugToFacetCode(slug: string): string {
    return `${BRAND_FACET_CODE}-${slug.replace(/-/g, " ")}`;
}

export function brandSlugToFilterTerm(slug: string): string {
    return slug.replace(/-/g, " ");
}
